import { Col, Container, Row } from "react-bootstrap";
import "./Services.css";

import sealing from "../../assets/img/SEALING-SERVICES.jpg";

import online from "../../assets/img/SERVICES.jpg";
import hologram from "../../assets/img/HOLOGRAM-SECURITY.jpg";

import { Link } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

export default function Services() {
  return (
    <>
      <section className="section-spacing-x section-spacing-y pt-0 section-service">
        <Container fluid>
          <Row>
            <div className="col-12 text-center">
              <h2 className="heading mb-3">Services</h2>
              <p className="section-service-para">
                At Sreehari Diamond Laboratory, we specialize in the creation of
                high-quality, certified lab-grown diamonds using advanced CVD
                and HPHT technologies. Our comprehensive services include
                diamond synthesis, grading, quality certification, and bespoke
                diamond solutions for both retail and wholesale clients. Every
                diamond is meticulously tested for purity and brilliance,
                meeting the most stringent international standards.
              </p>
            </div>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded ">
                <div className="service-image mx-auto">
                  <img src={sealing} alt="service" className="img-fluid" />
                </div>
                <Link to="/diamond-sealing-service">
                  <h3 className="mt-0">Sealing Service</h3>
                </Link>
                <p className="mt-0">
                  We provide secure sealing services that protect each certified
                  diamond with tamper-proof packaging, guaranteeing the
                  integrity of every diamond.{" "}
                </p>
                <div className="service-read-more ">
                  <Link to="/diamond-sealing-service">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={online}
                    alt="Online Certificate Verification Service | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/online-certificate-verification">
                  <h3 className="mt-0">Online Service</h3>
                </Link>

                <p className="mt-0">
                  Our convenient online service enables clients to access
                  certificates, verify authenticity, and track their diamond
                  orders at any time and from anywhere.{" "}
                </p>
                <div className="service-read-more ">
                  <Link to="/online-certificate-verification">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={hologram}
                    alt="Diamond Hologram Security Stickers | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/diamond-hologram-stickers">
                  <h3 className="mt-0">Hologram Security </h3>
                </Link>

                <p className="mt-0">
                  To enhance security, we utilize hologram stickers for
                  certificates with unique serial numbers and QR codes, allowing
                  each diamond to be instantly verified.{" "}
                </p>
                <div className="service-read-more ">
                  <Link to="/diamond-hologram-stickers">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
}
